import { render, staticRenderFns } from "./ClasificacionPatenteTable.vue?vue&type=template&id=527b15c2&scoped=true&"
import script from "./ClasificacionPatenteTable.vue?vue&type=script&lang=js&"
export * from "./ClasificacionPatenteTable.vue?vue&type=script&lang=js&"
import style0 from "./ClasificacionPatenteTable.vue?vue&type=style&index=0&id=527b15c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527b15c2",
  null
  
)

export default component.exports